import React from 'react';
import PropTypes from 'prop-types';
var FilterCollectionElementView = function FilterCollectionElementView(_ref) {
  var id = _ref.id,
    checked = _ref.checked,
    onChange = _ref.onChange,
    label = _ref.label;
  return /*#__PURE__*/React.createElement("li", {
    className: "collection-element"
  }, /*#__PURE__*/React.createElement("label", {
    className: "collection-element__wrapper"
  }, label, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    value: id,
    checked: checked,
    onChange: onChange,
    className: "collection-element__input"
  }), /*#__PURE__*/React.createElement("span", {
    className: "collection-element__checkmark"
  })));
};
FilterCollectionElementView.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string
};
FilterCollectionElementView.defaultProps = {
  checked: false,
  label: '',
  onChange: function onChange() {
    return null;
  }
};
export default FilterCollectionElementView;